import * as React from 'react';
import { RadioButtonGroupWithContent } from '@grandvisionhq/common';

const PaymentMethodsUI = ({ handleChange , paymentMethodItems , selectedPaymentMethodType  })=>{
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(RadioButtonGroupWithContent, {
        scope: "paymentMethod",
        items: paymentMethodItems,
        value: selectedPaymentMethodType,
        onChange: handleChange
    }));
};

export { PaymentMethodsUI };
//# sourceMappingURL=PaymentMethodsUI.js.map
